module.exports = __webpack_public_path__ + "img/head.fb544965.png";